import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { forwardRef } from 'react'

export const OpenMenuButton = forwardRef<
  HTMLButtonElement,
  {
    icon: IconProp
    onClick: () => void
    ariaLabel?: string
  }
>((props, ref) => (
  <button
    ref={ref}
    type='button'
    aria-label={props.ariaLabel ?? 'Open picker'}
    onClick={props.onClick}
    className='self-stretch m-1 px-3 text-base-700 bg-base-100 border border-base-300 rounded-md'>
    <FontAwesomeIcon icon={props.icon} />
  </button>
))

// "Or …" link toggling a range picker between its duration and end views.
export const ViewToggle = ({
  onClick,
  label,
}: {
  onClick: () => void
  label: string
}) => (
  <div className='text-sm'>
    Or{' '}
    <button
      type='button'
      onClick={onClick}
      className='text-base-content-muted underline'>
      {label}
    </button>
  </div>
)
